import axios from 'axios'
import store from '../store'
import errorCode from '../utils/errorCode'
import { saveAs } from 'file-saver'
import router from "@/router";

axios.defaults.headers['Content-Type'] = 'application/json'
// import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { getToken } from "../utils/auth";
import { tansParams } from "../api/util";
import { blobValidate } from "../utils/ruoyi";
import cache from "../utils/cache";
let ApiUrl = localStorage.getItem('ApiUrl')

// 创建axios多个实例
export const formal = axios.create({
  // baseURL: 'http://192.168.0.236:8080',
  // baseURL: 'http://114.116.180.69:8080',
  // baseURL: 'http://192.168.10.253:8085', //五色石
  // timeout: '5000'
})
export const service = axios.create({
  // baseURL: 'http://wechat.fenghua-group.com' //五色石
  baseURL: process.env.VUE_APP_BASE_API,
  //baseURL: 'http://192.168.10.253:8080',
  // baseURL: 'http://114.116.180.69:8080',
})

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false }
// 若依request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // console.log(config.headers)
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    // url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      // console.log(sessionObj, "...............first");
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url; // 请求地址
      const s_data = sessionObj.data; // 请求数据
      const s_time = sessionObj.time; // 请求时间
      const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
      // console.log(s_url, s_data, s_time, "................second");
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const
          message = '数据正在处理，请勿重复提交'; console.warn(`[${s_url}]:` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  } return config
}, error => {
  console.log(error)
  // Promise.reject(error)
})
//响应拦截
service.interceptors.response.use(
  response => {
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return response.data
    }
    const { code, data, msg } = response.data
    if (code === 200) {
      return promptSuccess(code, msg, response.data)
    } else if (code === 500) {
      // Message({
      // message: msg,
      // type: 'error'
      // })
    } else if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        // MessageBox.confirm('登录状态已过期，您可以选择重新登录', '系统提示', {
        // confirmButtonText: '重新登录',
        // cancelButtonText: '取消',
        // type: 'warning'
        // }
        // ).then(() => {
        // isRelogin.show = false
        // store.dispatch("LogOut").then(() => {
        // window.location.href = location.href.replace(/#.*/, '') + "#/login";

        // }).catch(() => {
        // this.loading = false;
        // });
        // }).catch((e) => {
        // console.log(e)
        // isRelogin.show = false
        // })
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录11111。')
    } else {
      Notification.error({
        title: msg
      })
    }
  },

)

// 通用下载方法
export function download1(url, params, filename) {
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  })
  // return service.post(url, params, {
  return service.get(url, {
    /* transformRequest: [(params) => {
    return tansParams(params)
    }],*/
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    params
  }).then(async (data) => {
    console.log(data)
    const isLogin = await blobValidate(data);
    if (isLogin) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {

      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      // Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    // Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}
// 通用下载方法
export function download(url, params, filename) {
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  })
  return service.post(url, {
    transformRequest: [(params) => {
      return tansParams(params)
    }]
  }, {
    // return service.get(url, {
    // transformRequest: [(params) => {
    // return tansParams(params)
    // }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    params
  }).then(async (data) => {
    console.log(data, "调用接口")
    const isLogin = await blobValidate(data);
    if (isLogin) {
      const blob = new Blob([data])
      console.log(blob, "下载文件", isLogin);
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      // Message.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    // Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close();
  })
}

/**
* 提示错误
* @param CODE 错误码
* @param MSG 错误提示
* @param REJECT reject 内容
* @returns {Promise<never>}
  */
const promptError = (CODE, MSG, REJECT) => {
  //错误描述
  return Promise.reject(REJECT)
}
/**
* 成功提示
* @param CODE 响应码
* @param MSG 成功提示
* @param RESOLVE resolve 内容
* @returns {Promise<never>}
  */
const promptSuccess = (CODE, MSG, RESOLVE) => {
  //错误描述
  return Promise.resolve(RESOLVE)
}

      //项目服务器
      // formal.interceptors.response.use(
      // config => {
      // // console.log(config.headers)
      // // 是否需要设置 token
      // const isToken = (config.headers || {}).isToken === false
      // // 判断本地的cookie中是否有token
      // if (getToken() && !isToken) {
      // config.headers.Authorization = 'Bearer ' + getToken()
      // // console.log(config.headers.Authorization)
      // } else {
      // // 跳转到登录页面(这里使用router，是因为路由文件引入到了此文件里)
      // router.push('/')
      // }
      // return config
      // }, err => {
      // console.log(err);
      // })


// WEBPACK FOOTER //
// ./src/utils/request.js